// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12448(63c7c71608)-C29/06/2026-12:04:59-B29/06/2026-12:11:20' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12448(63c7c71608)-C29/06/2026-12:04:59-B29/06/2026-12:11:20",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12448",
  shortHash: "63c7c71608",
  longHash: "63c7c71608cf63e6f95def9d08b4280bf6c09c1c",
  dateCommit: "29/06/2026-12:04:59",
  dateBuild: "29/06/2026-12:11:20",
  buildType: "Ansible",
  } ;
